import useAuth from './useAuth';

const useRole = () => {
    const { auth } = useAuth();

    const hasRole = (requiredRole) => {
        return Number(auth?.role) === requiredRole;
    };

    const hasAnyRole = (requiredRoles) => {
        return requiredRoles.includes(Number(auth?.role));
    };

    return { hasRole, hasAnyRole, userRole: auth?.role };
}

export default useRole;